// This sort of works like how a decorator would work when it gets implemented in the future.
// See https://github.com/tc39/proposal-decorators for details on that
// This function will simply add array like access to an object or class so that a class that simple contains a list
// and some other methods and so forth, gets the ability to work as if it was only the underlying list
// but with more methods. This works by implementing a Proxy trap that basically checks if we are acting on the object
// as we would with an array, and then redirects the interactions to our array prop
function ArrayAccessDecorator(type, arrayProp, { getter = null, setter = null } = {}) {
  return new Proxy(type, {
    get(target, prop, receiver) {
      // We check to make sure that the index is not defined on the object itself, and that it is a number type
      if (target[prop] === undefined && !Number.isNaN(Number.parseInt(prop.toString(), 10))) {
        if (getter !== null) return getter(target, prop, receiver)
        return target[arrayProp][prop] // / We access its index with our custom arrayProp
      }
      // Here we check if the property is any of the array properties and that the target haven't overwritten the method
      return Object.getOwnPropertyNames(Array.prototype).includes(prop) &&
        target[prop] === undefined
        ? // Here we are accessing an array method or property, therefore we are binding the array as the context,
          // otherwise it will be operating on an empty array of instances causing super weird errors
          target[arrayProp][prop].bind(target[arrayProp])
        : target[prop] // access property as normal
    },
    set(target, prop, value) {
      // We check to make sure that the index is not defined on the object itself, and that it is a number type
      if (target[prop] === undefined && !Number.isNaN(Number.parseInt(prop.toString(), 10))) {
        if (setter !== null) return setter(target, prop, value)
        // eslint-disable-next-line no-param-reassign
        target[arrayProp][prop] = value
      }
      // eslint-disable-next-line no-param-reassign
      target[prop] = value
      return true // Property was assigned correctly
    },
  })
}

export default class ArrayDecorator {
  constructor(ArrayData, settings = {}) {
    this.data = ArrayData
    // eslint-disable-next-line no-constructor-return
    return ArrayAccessDecorator(this, 'data', settings)
  }
}
